import React from "react";
import { useNavigate } from "react-router-dom";
import { FileText, Mail, ReceiptText, ClipboardList, ScanText, Plug, Cpu } from "lucide-react";
import { Breadcrumb, GradientPanel } from "../components/common";

const apps = [
  { id: "agents", icon: Cpu, title: "AI Agents", desc: "12 LLM-native agents automating the full e-invoicing pipeline.", path: "/a/agents", color: "from-violet-500 to-fuchsia-500" },
  { id: "extraction", icon: FileText, title: "Extraction", desc: "Define schemas and pull structured fields from documents.", path: "/a/extraction", color: "from-blue-500 to-indigo-500" },
  { id: "parse", icon: ScanText, title: "Parse", desc: "Turn uploaded documents into structured, reviewable data.", path: "/a/parse", color: "from-violet-500 to-fuchsia-500" },
  { id: "inbox", icon: Mail, title: "Inbox", desc: "Collect and classify incoming document emails.", path: "/a/inbox", color: "from-amber-500 to-orange-500" },
  { id: "einvoice", icon: ReceiptText, title: "E-Invoice", desc: "Create UAE FTA compliant e-invoices and send via PEPPOL.", path: "/a/e-invoice", color: "from-rose-500 to-pink-500" },
  { id: "jobs", icon: ClipboardList, title: "Parse Jobs", desc: "Monitor pending, completed and failed parsing jobs.", path: "/a/parse", color: "from-teal-500 to-emerald-500" },
  { id: "integrations", icon: Plug, title: "Integrations", desc: "Connect ERP, CRM, storage and email providers.", path: "/a/settings", color: "from-sky-500 to-cyan-500" },
];

const Apps = () => {
  const navigate = useNavigate();
  return (
    <div>
      <Breadcrumb items={[{ label: "Dashboard", path: "/a/dashboard" }, { label: "Apps" }]} />
      <GradientPanel>
        <h1 className="text-2xl font-bold text-gray-900">Apps</h1>
        <p className="text-sm text-gray-500 mt-1">Launch any module across your AI document workspace.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {apps.map((a) => (
            <button key={a.id} onClick={() => navigate(a.path)} className="text-left p-5 rounded-2xl border border-gray-100 card-soft hover-lift">
              <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${a.color} flex items-center justify-center text-white mb-3`}>
                <a.icon size={20} />
              </div>
              <h3 className="font-semibold text-gray-900">{a.title}</h3>
              <p className="text-sm text-gray-500 mt-1">{a.desc}</p>
            </button>
          ))}
        </div>
      </GradientPanel>
    </div>
  );
};

export default Apps;
